import { useLocalStorage } from '@frontend/web-storage';

export type TeamChatNotificationSettings = {
  showWhenOpen: boolean;
  showOnActiveConversation: boolean;
};

export const TEAM_CHAT_NOTIFICATION_SETTINGS_STORAGE_KEY = 'team-chat-notification-settings-v2';

export const DEFAULT_TEAM_CHAT_NOTIFICATION_SETTINGS: TeamChatNotificationSettings = {
  showWhenOpen: true,
  showOnActiveConversation: false,
};

/**
 * Source of truth for the team chat notification settings, backed by local storage.
 *
 * Safe to use outside of `TeamChatProvider`. Every instance reads and writes the same
 * storage key, and `useLocalStorage` publishes a storage event on write, so a change made
 * from the settings screen is picked up by the provider while both are mounted.
 */
export const useTeamChatNotificationSettings = () => {
  const [storedSettings, setNotificationSettings] = useLocalStorage<TeamChatNotificationSettings>({
    key: TEAM_CHAT_NOTIFICATION_SETTINGS_STORAGE_KEY,
    defaultValue: DEFAULT_TEAM_CHAT_NOTIFICATION_SETTINGS,
  });

  return [storedSettings ?? DEFAULT_TEAM_CHAT_NOTIFICATION_SETTINGS, setNotificationSettings] as const;
};
